import { LiteAppPostDataParam, UpdateLiteAppPostRequest } from '@/Interfaces/I_LiteApp';
import { VersionData } from '@/Interfaces/common';
import { customAxios } from '../index';

// Get lite app post
const fetchAllLiteAppPostAPI = () => customAxios.get(`/hktv_koc/cms/liteApp`);

// Add post to lite app
const createLiteAppPostAPI = (data: VersionData<LiteAppPostDataParam>) =>
  customAxios.post(`/hktv_koc/cms/liteApp/create`, data);

// delete post in lite app
const deleteLiteAppPostAPI = (data: VersionData<string>) =>
  customAxios.delete(`/hktv_koc/cms/liteApp/`, { data });

// update post in lite app
const updateLiteAppPostAPI = (data: VersionData<UpdateLiteAppPostRequest>) =>
  customAxios.post(`/hktv_koc/cms/liteApp`, data);

export { fetchAllLiteAppPostAPI, createLiteAppPostAPI, deleteLiteAppPostAPI, updateLiteAppPostAPI };
